<script setup>

import Header from "@/components/Header.vue";
import {nextTick, onMounted} from "vue";
import Footer from "@/components/Footer.vue";
import EmailForm from "@/components/EmailForm.vue";
import {useHead} from "@vueuse/head";


function loadScriptsSequentially(scripts, index = 0) {
  if (index < scripts.length) {
    const script = document.createElement('script');
    script.src = scripts[index];
    script.onload = () => loadScriptsSequentially(scripts, index + 1);
    document.body.appendChild(script);
  }
}


function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

onMounted(async () => {
// 先加载 jQuery
  await loadScript('/assets/js/vendor/jquery-3.5.1.min.js');

  // 然后加载其他依赖 jQuery 的脚本
  const otherScripts = [
      '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  await loadScriptsSequentially(otherScripts);

  // 确保脚本加载完成后再初始化
  await nextTick();

  // 检查 jQuery 和插件是否可用
  if (typeof $ !== 'undefined' && $.fn.venobox) {
    // 初始化 venobox
    $('.venobox').venobox();
  }
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})

</script>

<template>
  <Header/>
  <!-- witr_swiper_area -->
  <div class="witr_swiper_area video_page">
    <div class="swiper-container witr_active_id1">
      <div class="swiper-wrapper">
        <div class="swiper-slide witr_swiper_height">
          <div class="witr_sw_text_area text-left">
            <div class="witr_swiper_content white">
              <h1>Tpahousing</h1>
              <h2>The best company for your steel structure processing</h2>
              <p>A STEEL FABRICATION COMPANY OFFERS QUALITY SERVICES House.</p>
              <div class="slider_btn">
                <div class="witr_btn_style">
                  <div class="witr_btn_sinner">
                    <a class="witr_btn" href="/contact">Contact Now</a>
                    <a class="witr_btn active recpwit" href="/projects">More Service</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- witr_mp4_video -->
        <video autoplay="1" muted="1" loop="1" id="witr_mp4_video">
          <source src="/assets/images/2023-TPAHOUSING-04.mp4" type="video/mp4">
        </video>
      </div>
    </div>
  </div>

  <!-- kurigram_features_area -->
  <div class="kurigram_features_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Our Feature</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row features_top">
        <!-- kurigram_features_01 -->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="witr_feature_3d witr_feature_con_3d witr_feature_flip_up ">
            <div class="witr_single_feature_3d all_feature_color text-center">
              <!-- fontent -->
              <div class="witr_feature_front_3d">
                <div class="witr_feature_position">
                  <div class="witr_feature_content_3d">
                    <div class="witr_feature_icon_3d">
                      <i class="flaticon flaticon-monitor-1"></i>
                    </div>
                    <h3><a href="/projects">High precision and standardized production</a></h3>
                    <p>Factory prefabrication, modular design, technical support </p>
                  </div>
                  <div class="witr_feature_btn_3d">
                    <a href="/projects">Read More</a>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_feature_back_3d">
                <div class="witr_feature_position">
                  <div class="witr_feature_content_3d">
                    <div class="witr_feature_icon_3d">
                      <i class="flaticon flaticon-monitor-1"></i>
                    </div>
                    <h3><a href="/projects">High precision and standardized production</a></h3>
                    <p>Factory prefabrication, modular design, technical support</p>
                  </div>
                  <div class="witr_feature_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- kurigram_features_02 -->
        <div class="col-lg-4 col-md-6 col-sm-12 all_color_bg">
          <div class="witr_feature_3d witr_feature_con_3d witr_feature_flip_up ">
            <div class="witr_single_feature_3d all_feature_color text-center">
              <!-- fontent -->
              <div class="witr_feature_front_3d">
                <div class="witr_feature_position">
                  <div class="witr_feature_content_3d">
                    <div class="witr_feature_icon_3d">
                      <i class="flaticon flaticon-growth"></i>
                    </div>
                    <h3><a href="/projects">High material strength and lightweight</a></h3>
                    <p>High strength steel, lightweight design, ductility and seismic resistance </p>
                  </div>
                  <div class="witr_feature_btn_3d">
                    <a href="/projects">Read More</a>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_feature_back_3d">
                <div class="witr_feature_position">
                  <div class="witr_feature_content_3d">
                    <div class="witr_feature_icon_3d">
                      <i class="flaticon flaticon-growth"></i>
                    </div>
                    <h3><a href="/projects">High material strength and lightweight</a></h3>
                    <p>High strength steel, lightweight design, ductility and seismic resistance</p>
                  </div>
                  <div class="witr_feature_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- kurigram_features_03 -->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="witr_feature_3d witr_feature_con_3d witr_feature_flip_up ">
            <div class="witr_single_feature_3d all_feature_color text-center">
              <!-- fontent -->
              <div class="witr_feature_front_3d">
                <div class="witr_feature_position">
                  <div class="witr_feature_content_3d">
                    <div class="witr_feature_icon_3d">
                      <i class="aprova aprova-screen"></i>
                    </div>
                    <h3><a href="/projects">Efficient connection and construction flexibility</a></h3>
                    <p>Diversified connection methods, fast construction, detachable and environmentally friendly</p>
                  </div>
                  <div class="witr_feature_btn_3d">
                    <a href="/projects">Read More</a>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_feature_back_3d">
                <div class="witr_feature_position">
                  <div class="witr_feature_content_3d">
                    <div class="witr_feature_icon_3d">
                      <i class="aprova aprova-screen"></i>
                    </div>
                    <h3><a href="/projects">Efficient connection and construction flexibility</a></h3>
                    <p>Diversified connection methods, fast construction, detachable and environmentally friendly</p>
                  </div>
                  <div class="witr_feature_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- single_creative_area -->
  <div class="single_creative_area v4">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="witr_play_vi witr_all_color_v">
            <div class="witr_videobg_image">
              <img src="/assets/images/blog45.jpg" alt="">
              <div class="play-overlay ">
                <a class="video-popup video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"
                   href="https://www.youtube.com/watch?v=BS94ZOIqoNo">
                  <i class="fas fa-play"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="witr_lf_title">
            <div class="witr_section_title">
              <div class="witr_section_title_inner text-left">
                <h2>WHO WE ARE</h2>
                <h3>Foshan TianPuAn Building Materials Technology Co.,Ltd.</h3>
                <div class="witr_bar_main">
                  <div class="witr_bar_inner"></div>
                </div>
                <p>We are a steel fabrication company that offers quality services, including design, manufacturing,
                  and project installation management for steel frame buildings. eg. warehouse, workshop, storage,
                  exhibition hall, stadiums, hangars, logistics center, high-rise steel constructions,
                  multi-story residential housing, etc.</p>
              </div>
            </div>
            <div class="witr_button_area">
              <div class="witr_btn_style mr">
                <div class="witr_btn_sinner">
                  <a href="/about" class="witr_btn">Read More</a>
                  <a href="/contact" class="witr_bbtn">Our Contact</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_serivce_bg_area -->
  <div class="kurigram_serivce_bg_area serivce_v6">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Our Service</h3>
              <div class="witr_bar_main">
                <div class="witr_bar_inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row service_top service_style1">
        <!-- kurigram_serivce_bg_01 -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="witr_service_3d witr_service_con_3d witr_service_flip_zoomin">
            <div class="witr_single_service_3d all_color_service text-center ">
              <!-- fontent -->
              <div class="witr_service_front_3d">
                <div class="witr_service_position">
                  <div class="witr_service_content_3d ">
                    <div class="witr_service_icon_3d all_icon_color">
                      <i class="flaticon flaticon-temporary-agency"></i>
                    </div>
                    <h3>Architectural Design </h3>
                    <p>We provide architectural design services for building & construction industry.</p>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_service_back_3d">
                <div class="witr_service_position ">
                  <div class="witr_service_content_3d">
                    <div class="witr_service_icon_3d all_icon_color"></div>
                    <h3><a href="/projects">Reconstruction</a></h3>
                    <p>Our professional reconstruction solutions are very reliable and dependable.</p>
                  </div>
                  <div class="witr_service_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- kurigram_serivce_bg_02 -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="witr_service_3d witr_service_con_3d witr_service_flip_zoomin">
            <div class="witr_single_service_3d all_color_service text-center ">
              <!-- fontent -->
              <div class="witr_service_front_3d service_thumb1">
                <div class="witr_service_position">
                  <div class="witr_service_content_3d ">
                    <div class="witr_service_icon_3d all_icon_color">
                      <i class="flaticon flaticon-mail"></i>
                    </div>
                    <h3>General Contracting</h3>
                    <p>We can offer a reliable general contractor for all your construction needs.</p>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_service_back_3d service_thumb1">
                <div class="witr_service_position ">
                  <div class="witr_service_content_3d">
                    <div class="witr_service_icon_3d all_icon_color"></div>
                    <h3><a href="/projects">Consulting</a></h3>
                    <p>Our experts are always ready to consult you on any civil engineering related topic.</p>
                  </div>
                  <div class="witr_service_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- kurigram_serivce_bg_03 -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="witr_service_3d witr_service_con_3d witr_service_flip_zoomin">
            <div class="witr_single_service_3d all_color_service text-center ">
              <!-- fontent -->
              <div class="witr_service_front_3d service_thumb2">
                <div class="witr_service_position">
                  <div class="witr_service_content_3d">
                    <div class="witr_service_icon_3d all_icon_color">
                      <i class="aprova aprova-digital-marketing"></i>
                    </div>
                    <h3>Production consultation</h3>
                    <p>Assist customers in understanding product production</p>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_service_back_3d service_thumb2">
                <div class="witr_service_position ">
                  <div class="witr_service_content_3d">
                    <div class="witr_service_icon_3d all_icon_color"></div>
                    <h3><a href="/projects">Green Construction</a></h3>
                    <p>Green construction reduces expenses and negative impact on environment.</p>
                  </div>
                  <div class="witr_service_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- kurigram_serivce_bg_04 -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="witr_service_3d witr_service_con_3d witr_service_flip_zoomin">
            <div class="witr_single_service_3d all_color_service text-center ">
              <!-- fontent -->
              <div class="witr_service_front_3d service_thumb3">
                <div class="witr_service_position">
                  <div class="witr_service_content_3d ">
                    <div class="witr_service_icon_3d all_icon_color">
                      <i class="flaticon flaticon-computer"></i>
                    </div>
                    <h3>Quotation consultation</h3>
                    <p>Assist customers in product price planning</p>
                  </div>
                </div>
              </div>
              <!-- bekend -->
              <div class="witr_service_back_3d service_thumb3">
                <div class="witr_service_position ">
                  <div class="witr_service_content_3d">
                    <div class="witr_service_icon_3d all_icon_color"></div>
                    <h3><a href="/projects">Quality Control</a></h3>
                    <p>We control the quality of all our projects, especially the most complex ones.</p>
                  </div>
                  <div class="witr_service_btn_3d">
                    <a href="/projects">See More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_project_area -->
  <div class="kurigram_project_area project_v5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Our Factory</h3>
              <div class="witr_bar_main">
                <div class="witr_bar_inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="witr_pslide3 all_pslides_color ps1 ps3 service_active">
        <div class="witr_cslide3_idany project_top">
          <!-- kurigram_project_01 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/index_factory1_22231.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_number_pslide">
                  <h4>01</h4>
                </div>
                <div class="witr_content_pslide">
                  <h3><a href="/about">H Beam Processing</a></h3>
                </div>
                <div class="witr_pslide_custom">
                  <a href="/about"><span class="ti-arrow-right"></span></a>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_project_02 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/index_factory2_22232.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_number_pslide">
                  <h4>02</h4>
                </div>
                <div class="witr_content_pslide">
                  <h3><a href="/about">Steel Plate Cutting</a></h3>
                </div>
                <div class="witr_pslide_custom">
                  <a href="/about"><span class="ti-arrow-right"></span></a>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_project_03 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/index_factory3_22233.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_number_pslide">
                  <h4>03</h4>
                </div>
                <div class="witr_content_pslide">
                  <h3><a href="/about">Welding H Beam</a></h3>
                </div>
                <div class="witr_pslide_custom">
                  <a href="/about"><span class="ti-arrow-right"></span></a>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_project_04 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/index_factory4_22234.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_number_pslide">
                  <h4>04</h4>
                </div>
                <div class="witr_content_pslide">
                  <h3><a href="/about">Parts Welding</a></h3>
                </div>
                <div class="witr_pslide_custom">
                  <a href="/about"><span class="ti-arrow-right"></span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_project_area -->
  <div class="kurigram_project_area project_v5">
    <div class="containers">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Our Projects</h3>
              <div class="witr_bar_main">
                <div class="witr_bar_inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="witr_pslide2 all_pslides_color ps1 ps2 service_active">
        <div class="witr_cslide2_idany project_top">
          <!-- kurigram_project_01 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/pl179398155-customizable_sliding_window_steel_garage_buildings.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_content_pslide">
                  <h3><a href="/projects/Customizable-Sliding-Window-Steel-Garage-Buildings">Customizable Buildings</a></h3>
                </div>
              </div>
              <div class="witr_pslide_custom">
                <a href="/projects/Customizable-Sliding-Window-Steel-Garage-Buildings"><span class="ti-arrow-right"></span></a>
              </div>
            </div>
          </div>
          <!-- kurigram_project_02 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/pl175149566-the_existence_of_multistory_steel_carport_structures_with_premium_building_material.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_content_pslide">
                  <h3><a href="/projects/The-Existence-Of-Multistory-Steel-Carport-Structures-With-Premium-Building-Material">Steel Carport Structures</a></h3>
                </div>
              </div>
              <div class="witr_pslide_custom">
                <a href="/projects/The-Existence-Of-Multistory-Steel-Carport-Structures-With-Premium-Building-Material"><span class="ti-arrow-right"></span></a>
              </div>
            </div>
          </div>
          <!-- kurigram_project_03 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/pl171470707-hot_styles_prefab_houses_steel_structure_hall_building.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_content_pslide">
                  <h3><a href="/projects/Hot-Styles-Prefab-Houses-Steel-Structure-Hall-Building">Hot Styles Prefab Houses</a></h3>
                </div>
              </div>
              <div class="witr_pslide_custom">
                <a href="/projects/Hot-Styles-Prefab-Houses-Steel-Structure-Hall-Building"><span class="ti-arrow-right"></span></a>
              </div>
            </div>
          </div>
          <!-- kurigram_project_04 -->
          <div class="item_pos col-lg-12">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img src="/assets/images/pl171139738-eco_friendly_metal_building_materials_double_storey_prefab_house.jpg" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_content_pslide">
                  <h3><a href="/projects/Eco-Friendly-Metal-Building-Materials-Double-Storey-Prefab-House">Double Storey Prefab House</a></h3>
                </div>
              </div>
              <div class="witr_pslide_custom">
                <a href="/projects/Eco-Friendly-Metal-Building-Materials-Double-Storey-Prefab-House"><span class="ti-arrow-right"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- single_faq_bg_area -->
  <div class="single_faq_bg_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3> Frequently Asked Questions</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row faq_top">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="single_image_area">
            <div class="single_image  ">
              <img src="/assets/images/ab3.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="accordion_area faq_style2">
            <div class="faq-part">
              <div id="accordion">
                <div class="card card-2 active show">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style collapsed" data-toggle="collapse"
                       data-target="#collapse_05" aria-expanded="false">
                      What is the maximum depth that your steel building can span?</a>
                  </div>
                  <div id="collapse_05" class=" collapse  active show" data-parent="#accordion" style="">
                    <p>Our buildings are engineered to span from 9 meters up to 40 meters clear span and further if
                      needed.</p>
                  </div>
                </div>
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_01"
                       aria-expanded="true">
                      How to protect steel structure frame from rusting?</a>
                  </div>
                  <div id="collapse_01" class="collapse   " data-parent="#accordion">
                    <p>There are two methods:2 layers(30microns+30microns)auti-rust coating and hot-dip galvanized.If
                      the house is near the coast wesuggest using galvanized solution,cause it can last longer.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_02"
                       aria-expanded="true">
                      Is it easy to install a steel building?</a>
                  </div>
                  <div id="collapse_02" class="collapse   " data-parent="#accordion">
                    <p>It is not so difficult to install this kind of steel house building, we will guide you with an
                      installation instruction drawing, the construction is a simple bolt-together process, and you just
                      need a crane of about 20ton to help with the installation work.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_03"
                       aria-expanded="true">
                      Why does wind speed affect prices that much?</a>
                  </div>
                  <div id="collapse_03" class="collapse   " data-parent="#accordion">
                    <p>For most of the steel structure buildings, we design wind speed is about 110km/h. But for some
                      strong wind countries,110km/h is not enough, like the Philippines and Mauritius 150~280km/h
                      windspeed need to enlarge the beam and column, that will use more steel on it then increase the
                      price a lot.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_04"
                       aria-expanded="true">
                      What accessories do you provide for customizing steel buildings?</a>
                  </div>
                  <div id="collapse_04" class="collapse   " data-parent="#accordion">
                    <p>Along with the wall and roof insulation systems, we also offer skylights, commercial-grade
                      ventilation devices such as roof turbine vents and wall louver vents, rolling doors, and double
                      sliding doors.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_05"
                       aria-expanded="true">
                      Is it beter to add a brick wall to my metal building?</a>
                  </div>
                  <div id="collapse_05" class="collapse   " data-parent="#accordion">
                    <p>Yes,it is.The brick wall can be moisture resistance and also fire resistance. 1~3m high brick
                      wall combine the metal sheet or sandwich panel will be durable and look nice.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_06"
                       aria-expanded="true">
                      What kind of steel sections you can produce?</a>
                  </div>
                  <div id="collapse_06" class="collapse   " data-parent="#accordion">
                    <p>For the steel building mostly we make Q235B and Q355B H beam. That includes standard section and
                      customized section(also call Tapered section). The customized section may use less steel, because
                      it is just one end bigger, not like the standard section with two ends same size. But will need
                      production time and need more labor cost. </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_counter_bg_area -->
  <div class="kurigram_counter_bg_area counter_page">
    <div class="container">
      <div class="row counter3">
        <!-- kurigram_counter_01 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-man-1"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">2010</h3>
              <span>+</span>
              <h4>Founded </h4>
            </div>
          </div>
        </div>
        <!-- kurigram_counter_02 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-team"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">58</h3>
              <span>+</span>
              <h4>Team</h4>
            </div>
          </div>
        </div>
        <!-- kurigram_counter_03 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-computer"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">60</h3>
              <span>+</span>
              <h4>Export</h4>
            </div>
          </div>
        </div>
        <!-- kurigram_counter_04 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-select"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">4</h3>
              <span>+</span>
              <h4>Certificates</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  &lt;!&ndash; kurigram_team_area &ndash;&gt;-->
<!--  <div class="kurigram_team_area team_style4">-->
<!--    <div class="container">-->
<!--      <div class="row">-->
<!--        <div class="col-lg-12">-->
<!--          <div class="witr_section_title">-->
<!--            <div class="witr_section_title_inner text-center">-->
<!--              <h3>Our Team</h3>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row team_top">-->
<!--        &lt;!&ndash; kurigram_team_01 &ndash;&gt;-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12">-->
<!--          <div class="em-team all_color_team ">-->
<!--            <div class="em-team-one">-->
<!--              <div class="em-team-content-image-inner">-->
<!--                <div class="em-team-content-image">-->
<!--                  <img src="/assets/images/business1.png" alt=""/>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="em-team-content-waraper all_content_bg_color">-->
<!--                <div class="em-team-content-title-inner">-->
<!--                  <div class="em-content-title">-->
<!--                    <h5><a href="#">Ray Chan</a></h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-subtitle-inner">-->
<!--                  <div class="em-content-subtitle">-->
<!--                    <span>Sales Manager</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-socials-inner">-->
<!--                  <div class="em-team-content-socials all_team_s_color">-->
<!--                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i-->
<!--                        class="icofont-facebook"></i></a>-->
<!--                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i-->
<!--                        class="icofont-youtube"></i></a>-->
<!--                    <a href="https://api.whatsapp.com/send?phone=8613929160928"><i class="icofont-whatsapp"></i></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; kurigram_team_02 &ndash;&gt;-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12">-->
<!--          <div class="em-team all_color_team ">-->
<!--            <div class="em-team-one">-->
<!--              <div class="em-team-content-image-inner">-->
<!--                <div class="em-team-content-image">-->
<!--                  <img src="/assets/images/business2.png" alt=""/>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="em-team-content-waraper all_content_bg_color">-->
<!--                <div class="em-team-content-title-inner">-->
<!--                  <div class="em-content-title">-->
<!--                    <h5><a href="#">Kary Huang</a></h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-subtitle-inner">-->
<!--                  <div class="em-content-subtitle">-->
<!--                    <span>Sales Supervisor</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-socials-inner">-->
<!--                  <div class="em-team-content-socials all_team_s_color">-->
<!--                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i-->
<!--                        class="icofont-facebook"></i></a>-->
<!--                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i-->
<!--                        class="icofont-youtube"></i></a>-->
<!--                    <a href="https://api.whatsapp.com/send?phone=8613929163028"><i class="icofont-whatsapp"></i></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; kurigram_team_03 &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <EmailForm/>


  <!-- kurigram_blog_bg_area -->
  <div class="kurigram_blog_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Blogs</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="witr_blog_area11 blog_top">
        <div class="blog_wrap blog11_idblog1">
          <!-- kurigram_blog_bg_01 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/2335-m2-steel-structure-office-and-warehouse(Israel)"> <img src="/assets/images/ad35051081-2335_m2_steel_structure_office_and_warehouse_israel.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/2335-m2-steel-structure-office-and-warehouse(Israel)">2335 m2 steel structure office and warehouse(Israel)</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_blog_bg_02 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/Steel-structure-metal-building-homes-in-Netherlands"> <img src="/assets/images/ad33908090-steel_structure_metal_building_homes_in_netherlands.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/Steel-structure-metal-building-homes-in-Netherlands">Steel structure metal building homes in Netherlands</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_blog_bg_03 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/126-sqm-STEEL-STRUCTURE-SEAFOOD-STORAGE-(Vancouver,-CA)"> <img src="/assets/images/ad35186593-126_sqm_steel_structure_seafood_storage_vancouver_ca.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/126-sqm-STEEL-STRUCTURE-SEAFOOD-STORAGE-(Vancouver,-CA)">126 sqm STEEL STRUCTURE SEAFOOD STORAGE (Vancouver, CA)</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_blog_bg_04 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/Metal-steel-structure-frame-gas-station(Tanzania)"> <img src="/assets/images/ad35104414-metal_steel_structure_frame_gas_station_tanzania.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/Metal-steel-structure-frame-gas-station(Tanzania)">Metal steel structure frame gas station(Tanzania)</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>

</template>


